import {
  GET_LEAD_LISTS,
  GET_PROJECT_LISTS,
  GET_USER_LISTS,
  CREATE_LEAD_PLAN_OFFER,
  UPDATE_LEAD_PLAN_OFFER,
  DELETE_LEAD_PLAN_OFFER,
  CREATE_LEAD_PLAN,
  UPDATE_LEAD_PLAN,
  DELETE_LEAD_PLAN,
  CREATE_LEAD_OFFER,
  UPDATE_LEAD_OFFER,
  DELETE_LEAD_OFFER,
  START_LOADING,
  STOP_LOADING,
  ERROR
} from '../LeadsAction/types';

const INITIAL_STATE = {
  loading: false,
  success: false,
  leads_list: [],
  users_list: [],
  lead_plan_offer: [],
  error_message: ''
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_LEAD_LISTS:
      return {
        ...state,
        leads_list: action.payload,
        success: false,
        loading: false
      }
    case GET_PROJECT_LISTS:
      return {
        ...state,
        projects_list: action.payload,
        success: false
      }
    case GET_USER_LISTS:
      return {
        ...state,
        users_list: action.payload,
        success: false
      }
    case CREATE_LEAD_PLAN_OFFER:
      return {
        ...state,
        lead_plan_offer: action.payload,
        success: false
      }
    case UPDATE_LEAD_PLAN_OFFER:
      return {
        ...state,
        lead_plan_offer: action.payload,
        success: false
      }
    case DELETE_LEAD_PLAN_OFFER:
      return {
        ...state,
        lead_plan_offer: action.payload,
        success: false
      }
    case CREATE_LEAD_PLAN:
      return {
        ...state,
        lead_plans: action.payload,
        success: false
      }
    case UPDATE_LEAD_PLAN:
      return {
        ...state,
        lead_plans: action.payload,
        success: false
      }
    case DELETE_LEAD_PLAN:
      return {
        ...state,
        lead_plans: action.payload,
        success: false
      }
    case CREATE_LEAD_OFFER:
      return {
        ...state,
        lead_offers: action.payload,
        success: false
      }
    case UPDATE_LEAD_OFFER:
      return {
        ...state,
        lead_offers: action.payload,
        success: false
      }
    case DELETE_LEAD_OFFER:
      return {
        ...state,
        lead_offers: action.payload,
        success: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        error_message: action.payload,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}